import Card from "components/card";
import Button from "components/button/Button";
import CommonModal from "components/modals/Modal";
import { createPortal } from "react-dom";
import { useDisclosure } from "@chakra-ui/hooks";
import { numericFormatter } from "react-number-format";
import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";
import { Image } from "views/admin/goods/types/goods.interface";
import InputField from "components/fields/InputField";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";

const ProductCardAssign = (props: {
  id: number;
  thumbnail: string;
  images: Image[];
  title: string;
  category: string;
  price: string | number;
  sku: string;
  description: string;
  extra?: string;
  slug: string;
  weight: number;
  onDelete?: (slug: string) => void;
  onAssign?: (product_id: number, name: string, stock: number) => void;
}) => {
  const { id, title, category, price, thumbnail, extra, weight, onAssign } =
    props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    onAssign(id, title, data.stock);
    onClose();
  };

  return (
    <>
      <Card
        extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white ${extra}`}
      >
        <div className="h-full w-full">
          <div className="relative w-full overflow-hidden">
            <img
              src={
                thumbnail
                  ? `${process.env.REACT_APP_PUBLIC_URL}/${thumbnail}`
                  : "https://placehold.co/600x400?text=No+Thumbnail"
              }
              className="mb-3 h-56 w-full rounded-xl object-cover object-center"
              alt=""
            />
          </div>

          <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
            <div className="mb-2">
              <p className="text-lg font-bold text-navy-700 dark:text-white">
                {" "}
                {title}
              </p>
              <div className="flex flex-col">
                <p className="mt-1 text-sm font-medium text-gray-600">
                  Kategori : <span className="text-brand-500">{category}</span>
                </p>
                <p className="text-sm font-medium text-gray-600">
                  Berat : <span className="text-brand-500">{weight} gr</span>
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
            <div className="flex">
              <p className="mb-2 text-lg font-bold text-navy-700 dark:text-white">
                {numericFormatter(price.toString(), {
                  decimalSeparator: ",",
                  thousandSeparator: ".",
                  prefix: "Rp",
                })}
              </p>
            </div>
            <div className="flex items-center justify-between gap-2">
              <Button
                size="fit"
                children="Pilih"
                variant="primary"
                onClick={() => {
                  onOpen();
                }}
              />
            </div>
          </div>
        </div>
      </Card>
      {createPortal(
        <CommonModal
          size="2xl"
          children={
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalHeader>{title}</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <InputField
                  id="stock"
                  label="Stok"
                  placeholder="Masukkan Stok"
                  extra="mb-3"
                  errors={errors}
                  register={register}
                  variant="outline"
                  validationSchema={{
                    required: "Stok harus diisi!",
                  }}
                />
              </ModalBody>
              <ModalFooter>
                <div className="flex gap-3">
                  <Button
                    size="fit"
                    children="Batal"
                    variant="gray"
                    onClick={onClose}
                  />
                  <Button
                    size="fit"
                    children="Tambah"
                    variant="primary"
                    type="submit"
                  />
                </div>
              </ModalFooter>
            </form>
          }
          isOpen={isOpen}
          onClose={onClose}
        />,
        document.body
      )}
    </>
  );
};

export default ProductCardAssign;
